import { render, staticRenderFns } from "./Tktest.vue?vue&type=template&id=6b77430f&scoped=true"
import script from "./Tktest.vue?vue&type=script&lang=js"
export * from "./Tktest.vue?vue&type=script&lang=js"
import style0 from "./Tktest.vue?vue&type=style&index=0&id=6b77430f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b77430f",
  null
  
)

export default component.exports